import IdleLogOut from './IdleLogOut.container'

export default IdleLogOut
